import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useKlaviyoConfigurationQuery = createQueryHook(
  CreatorIntegrationsApiClient.getKlaviyoConfiguration,
  {
    queryKey: ['klaviyoConfiguration'],
  },
)
